import { PromoBadge } from '@/components/PromoBadge';
import { QuantityBadge } from '@/components/QuantityBadge';
import type { PromoBadge as Badge, Image } from '@/types';
import { useEffect, useState } from 'react';
import * as Styled from './ProductThumbnail.styled';

const FALLBACK_PRODUCT_IMAGE = '/Styles/Images/easons.png';

interface ProductThumbnailProps {
  image: Image | null;
  isBook: boolean;
  promoBadge: Badge | null;
  quantity?: number;
}

export const ProductThumbnail = ({
  image,
  isBook,
  promoBadge,
  quantity,
}: ProductThumbnailProps) => {
  const preferredImageSource =
    image?.thumbnailSrc ?? image?.mainSrc ?? FALLBACK_PRODUCT_IMAGE;
  const [imageSource, setImageSource] = useState(preferredImageSource);

  useEffect(() => {
    setImageSource(preferredImageSource);
  }, [preferredImageSource]);

  return (
    <Styled.Wrapper $isBook={isBook}>
      <img
        alt={
          imageSource === FALLBACK_PRODUCT_IMAGE
            ? 'Image coming soon'
            : (image?.altText ?? '')
        }
        src={imageSource}
        onError={
          imageSource === FALLBACK_PRODUCT_IMAGE
            ? undefined
            : () => setImageSource(FALLBACK_PRODUCT_IMAGE)
        }
      />
      {quantity ? <QuantityBadge diameter={22} quantity={quantity} /> : null}
      {promoBadge ? (
        <PromoBadge altText={promoBadge.altText} src={promoBadge.src} />
      ) : null}
    </Styled.Wrapper>
  );
};
